// eslint-disable-next-line
/* global window, console */
const checkInterval = 1000; // 1s
const maxWaitTime = 10000; // 10s

/* eslint-disable no-console */
export default {
  getPlayer: rootElement => {
    return new Promise((resolve, reject) => {
      getVideoPlayer(rootElement)
        .then(player => {
          resolve(player);
        })
        .catch(reject);
    });
  }
};

/**
 * Get the sdc video component from the rootElement
 * @param rootElement
 * @returns {Promise<any>}
 */
const getVideoComponent = rootElement => {
  return new Promise((resolve, reject) => {
    const videoIFrame = rootElement.querySelector('.sdc-site-match-header__video-embed-iframe');
    const checkIframePlayer = (iFrameEl) => {
      if (!iFrameEl) {
        reject(new Error('Missing video component'));
      }
      const innerDoc = iFrameEl.contentDocument || iFrameEl.contentWindow.document;
      const iframeVideoComponent = getVideoComponentElement(innerDoc);
      if (!iframeVideoComponent) {
        return window.setTimeout(checkIframePlayer, checkInterval, iFrameEl);
      }
      resolve(iframeVideoComponent);
    };
    checkIframePlayer(videoIFrame);
  });
};

/**
 * Get video player for the highlight video
 * @param rootElement
 * @returns {Promise<any>}
 */
const getVideoPlayer = rootElement => {
  window.setTimeout(() => { // Return an error if no component is found after maxWaitTime
    return Promise.reject(new Error('Video component could not be found'));
  }, maxWaitTime);
  return getVideoComponent(rootElement);
};

const getVideoComponentElement = (rootElement) => {
  return rootElement.querySelector('[data-component-name="sdc-site-video"]') ||
    rootElement.querySelector('[data-component-name="sdc-site-view-manager"]');
};

/* eslint-enable */
